import styled from 'styled-components';
export var Wrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-7pe2f2-0"
})(["display:flex;align-items:center;flex-wrap:wrap;", " color:", ";svg{width:26px;height:auto;flex-shrink:0;flex-basis:26px;}ul{flex-basis:100%;padding-left:", ";font-size:", ";}h3{flex-basis:100%;font-size:", ";}"], function (_ref) {
  var theme = _ref.theme;
  return theme.gap(2);
}, function (props) {
  return props.theme.rentalConditionsSection.text.color;
}, function (props) {
  return props.theme.space(5.5);
}, function (props) {
  return props.theme.rem(14);
}, function (props) {
  return props.theme.rem(14);
});